import React from 'react';
import { FileText } from 'lucide-react';

interface SearchResultGroupProps {
  documentName: string;
  matchCount: number;
  onClickHeader: () => void;
  children: React.ReactNode;
}

export const SearchResultGroup: React.FC<SearchResultGroupProps> = ({
  documentName,
  matchCount,
  onClickHeader,
  children,
}) => {
  return (
    <div className="rounded-lg border border-medical-200 dark:border-medical-700 overflow-hidden">
      {/* Document header */}
      <button
        onClick={onClickHeader}
        className="w-full text-left flex items-center gap-2 px-3 py-2 bg-cyan-50/60 dark:bg-cyan-900/20 hover:bg-cyan-100/80 dark:hover:bg-cyan-900/30 transition-colors"
      >
        <FileText className="h-3.5 w-3.5 text-cyan-500 dark:text-cyan-400 flex-shrink-0" />
        <span className="text-xs font-medium text-medical-800 dark:text-medical-200 truncate flex-1 min-w-0">
          {documentName}
        </span>
        <span className="shrink-0 px-1.5 py-0.5 rounded-full text-[10px] font-semibold bg-cyan-100 text-cyan-700 dark:bg-cyan-800/40 dark:text-cyan-300">
          {matchCount}
        </span>
      </button>

      {/* Result items */}
      <div className="divide-y divide-medical-100 dark:divide-medical-700 bg-white dark:bg-medical-800">
        {children}
      </div>
    </div>
  );
};
